import { container } from 'assets/jss/material-dashboard-pro-react';
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'creative-components/Grid/GridContainer';
import GridItem from 'creative-components/Grid/GridItem';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    height: '100%',
    padding: '100px 0',
    textAlign: 'center',
  },
  container: {
    ...container,
    padding: '8px',
  },
  title: {
    color: theme.palette.darkGray.main,
    fontSize: '56px',
    lineHeight: '100px',

    [theme.breakpoints.down('sm')]: {
      fontSize: '40px',
      lineHeight: '80px',
    },
  },
  subtitle: {
    color: theme.palette.grayScale4.main,
    fontSize: '32px',
    lineHeight: '36px',

    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
  },
}));

export default function AgentLandingErrorPage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <GridContainer className={classes.container}>
        <GridItem xs={12}>
          <h1 className={classes.title}>This link is unavailable</h1>
          <h2 className={classes.subtitle}>It may have expired. Please try again.</h2>
        </GridItem>
      </GridContainer>
    </div>
  );
}
